<template>
  <v-container fluid>
    <v-layout justify-center>
      <v-flex xs7>
        <h2 class='amaze-title'>Amaze</h2>
        <p>Enter a password below that only you know.</p>
        <v-form v-model="valid" @keydown.enter="submitForm()">
          <p>Passwords must be at least 8 characters, contain at least one upper case letter and at least one digit.</p>
          <v-text-field label="Password" v-model="password" :rules="passwordRules" :append-icon="showPassword ? 'visibility' : 'visibility_off'"
          @click:append="showPassword = !showPassword"
          :type="showPassword ? 'text' : 'password'" required></v-text-field>
          <v-text-field label="Confirm Password" v-model="password_confirmation" :rules="passwordConfirmationRules" :append-icon="showPassword ? 'visibility' : 'visibility_off'"
          @click:append="showPassword = !showPassword"
          :type="showPassword ? 'text' : 'password'" required></v-text-field>
          <input type="hidden" name="token" v-model="token" />
          <v-btn color="primary" class="mt-5" @click="submitForm()">
            <span v-if="create">Set Password</span><span v-else>Reset it!</span>
          </v-btn>
        </v-form>
        <p class='mt-5' v-if="!create">
          <router-link to="/">Return to Login</router-link>
        </p>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      valid: false,
      email: this.$route.query.email,
      token: this.$route.query.token,
      create: this.$route.query.create || false,
      password: null,
      password_confirmation: null,
      showPassword: false,
      emailRules: [
        v => !!v || "Email is required",
        v => /@/.test(v) || "Don't forget the @ symbol"
      ],
      passwordRules: [
        v => /[A-Z]/.test(v) || "Passwords must have at least one upper case letter",
        v => /[0-9]/.test(v) || "Passwords must have at least one digit",
        v => v.length >= 8 || "Passwords must be 8 or more characters"
      ],
      passwordConfirmationRules: [
        v => v === this.password || "Passwords do not match"
      ]
    };
  },
  methods: {
    submitForm() {
      let formData = {
        email: this.email,
        password: this.password,
        password_confirmation: this.password_confirmation,
        token: this.token
      };
      this.$http.post("password/reset", formData).then(
        response => {
          this.$router.push({ path: "/" });
        },
        response => {
          this.$store.commit("updateMessage", {
            message:
                "We were not able to update the password. Please try again.",
            snackbar: true
          });
        }
      );
    }
  },
  mounted() {
    if (!this.$route.query.token) {
      this.$router.push({ path: "/missing-token" });
    }
  }
};
</script>
